Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "previewreset827662263",
  {"root":"previewreset827662263--root"},
  "",
  1,
  "previewreset827662263"
);

